import { settleApiCall } from '../../../api/utils';
import { getPriceVariantsIds } from '../../../utils/priceVariants';
import { createFieldToEntityMap } from '../../../utils/common';
export const getPriceVariants = async _ref => {
  let {
    priceVariantsClient,
    items,
    populationLevel,
    cacheVariants
  } = _ref;
  const shouldPopulatePriceVariants = populationLevel == null ? void 0 : populationLevel.priceVariants;
  if (!shouldPopulatePriceVariants) {
    return {
      data: [],
      hasError: false
    };
  }
  const itemsPriceVariantsIds = getPriceVariantsIds(items);
  if (!(itemsPriceVariantsIds.length > 0)) {
    return {
      data: [],
      hasError: false
    };
  }
  let variantsResult = [];
  if (cacheVariants) {
    variantsResult = cacheVariants;
  } else {
    const priceVariantsApiResponse = await settleApiCall(() => priceVariantsClient.getBulk({
      ids: itemsPriceVariantsIds
    }));
    if (priceVariantsApiResponse.hasError) {
      return priceVariantsApiResponse;
    }
    variantsResult = priceVariantsApiResponse.data.data;
  }
  const priceVariantsMap = createFieldToEntityMap(variantsResult, 'id');
  return {
    data: variantsResult,
    idsToEntityMap: priceVariantsMap,
    hasError: false
  };
};
//# sourceMappingURL=getPriceVariants.js.map